/**
 * Générateur — Automatisme : donner les carrés des nombres entiers compris
 * entre 0 et 12.
 * Attendu ID : 1105 | Niveau : 4ème | Domaine : Racine carrée
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 10, ligne 691 :
 * « Donner les carrés des nombres entiers compris entre 0 et 12. »,
 * répétée telle quelle en 3e l. 764).
 *
 * ── WRAPPER de gen_1101, RESTREINT AU SENS DIRECT (clés donner_*) ─────────
 * Arbitrage prof du 2026-09-12 (épreuve de Musk sur les deux intitulés) :
 * « DONNER les carrés » = partir de l'entier et produire le carré (9 → 81),
 * la récitation que la racine carrée prend pour socle (mise en œuvre
 * Eduscol 2026 p. 17) ; « RECONNAITRE les carrés parfaits » (1101, l. 675) =
 * partir d'un nombre et retrouver l'entier. Un fichier, deux jeux de clés
 * (modèle 1103/1104), aucune carte en commun : ici « Donner le carré »
 * (flash 7² = …) et « Combien vaut 7² ? » (QCM). Payload re-badgé (attendu
 * 1105) ; les solveurs sont ceux des clés donner_* de 1101.
 */
import { generate as genererCarres, CATEGORIES_DONNER } from './gen_1101';
import { randomChoice, retirerCodesErreur } from '../../../utils';

const ATTENDU_ID = 1105;

// Relecture du 04/10/2026 (docs/SFD_CODES_ERREUR.md) : base_fois_exposant et carre_voisin ne sont gardés que
// sur les cartes de 1103 et 1101 où le juge les a lus ; « Donner » ne lui a jamais été montrée (1220 la
// reprend). Le choix reste proposé, il part sans nom.
const CODES_RETIRES = {
    donner_qcm_unique: ['base_fois_exposant', 'carre_voisin'],
};

export const CATEGORIES = CATEGORIES_DONNER;

const CLES = CATEGORIES_DONNER.flatMap((c) => c.formatsList.map(({ key }) => key));

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && CLES.includes(typeExercice)) key = typeExercice;
    else if (typeExercice) {
        const matching = CLES.filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(CLES);
    } else key = randomChoice(CLES);
    const payload = genererCarres(key);
    payload.attendu = ATTENDU_ID;
    return retirerCodesErreur(payload, CODES_RETIRES[key]);
};
